import images from "./images";

const gallery = [
  {
    id: 1,
    image: images.gallery1,
    title: 'Hibiscus Tea',
    category: 'herbal tea',
  },
  {
    id: 2,
    image: images.gallery2,
    title: 'Chai Latte',
    category: 'chai tea',
  },
  {
    id: 3,
    image: images.gallery3,
    title: 'Chocolate Chai',
    category: 'black tea',
  },
  {
    id: 4,
    image: images.gallery4,
    title: 'Matcha',
    category: 'green tea',
  },
  {
    id: 5,
    image: images.gallery5,
    title: 'Peppermint Tea',
    category: 'herbal tea',
  },
  {
    id: 6,
    image: images.gallery6,
    title: 'Cardamom Tea',
    category: 'chai tea',
  },
  {
    id: 7,
    image: images.gallery7,
    title: 'Earl Gray Tea',
    category: 'black tea',
  },
  {
    id: 8,
    image: images.gallery8,
    title: 'Sencha',
    category: 'green tea',
  },
  {
    id: 9,
    image: images.gallery9,
    title: 'Chamomile Tea',
    category: 'herbal tea',
  },
];

export default gallery;